<template>
  <div id="main-content" class="add-day-off">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row>
          <el-col :span="4">
            <span class="required-star">* </span><span class="form-lable">{{ $t('common.title') }}</span>
          </el-col>
          <el-col :span="8">
            <input class="input" v-model="dayOffTitle" type="text" />
          </el-col>
          <el-col v-if="error_message.dayOffTitle" :span="12">
            <span v-for="(value, key) in error_message.dayOffTitle" :key="key" class="form-error"> {{ value }}</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="4">
            <span class="required-star">* </span><span class="form-lable">{{ $t('common.type') }}</span>
          </el-col>

          <el-col :span="8">
            <select v-model="type" class="input">
              <option value="">{{ $t('common.please_select') }}</option>
              <option :value="DAY_OFF_TYPE_DATE">{{ $t('common.date') }}</option>
              <option :value="DAY_OFF_TYPE_DAY">{{ $t('common.day') }}</option>
              <option :value="DAY_OFF_TYPE_PERIOD">{{ $t('common.period') }}</option>
            </select>
          </el-col>

          <el-col v-if="error_message.type" :span="12">
            <span v-for="(value, key) in error_message.type" :key="key" class="form-error"> {{ value }}</span>
          </el-col>
        </el-row>

        <template v-if="type === DAY_OFF_TYPE_DATE">
          <el-row>
            <el-col :span="4">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.date') }}</span>
            </el-col>
            <el-col :span="8">
              <el-date-picker
                  v-model="data.date.date"
                  type="date"
                  :placeholder="$t('common.pick_a_date')"
                  :picker-options="pickerOptions">
              </el-date-picker>
            </el-col>
            <el-col v-if="error_message.data.date.date" :span="12">
              <span v-for="(value, key) in error_message.data.date.date" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
        </template>

        <template v-else-if="type === DAY_OFF_TYPE_DAY">
          <el-row>
            <el-col :span="4">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.day') }}</span>
            </el-col>
            <el-col :span="8">
              <el-select v-model="data.day.day" :placeholder="$t('common.day')">
                <el-option v-for="(label, value) in DAY_LIST_FULL" :key="value" :value="value" :label="label"></el-option>
              </el-select>
            </el-col>
            <el-col v-if="error_message.data.day.day" :span="12">
              <span v-for="(value, key) in error_message.data.day.day" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.start_date') }}</span>
            </el-col>
            <el-col :span="8">
              <el-date-picker
                  v-model="data.day.startDate"
                  type="date"
                  :placeholder="$t('common.pick_a_date')"
                  :picker-options="pickerOptions">
              </el-date-picker>
            </el-col>
            <el-col v-if="error_message.data.day.startDate" :span="12">
              <span v-for="(value, key) in error_message.data.day.startDate" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.end_date') }}</span>
            </el-col>
            <el-col :span="8">
              <el-date-picker
                  v-model="data.day.endDate"
                  type="date"
                  :placeholder="$t('common.pick_a_date')"
                  :picker-options="pickerOptions">
              </el-date-picker>
            </el-col>
            <el-col v-if="error_message.data.day.endDate" :span="12">
              <span v-for="(value, key) in error_message.data.day.endDate" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
        </template>

        <template v-else-if="type === DAY_OFF_TYPE_PERIOD">
          <el-row>
            <el-col :span="4">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.start_date') }}</span>
            </el-col>
            <el-col :span="8">
              <el-date-picker
                  v-model="data.period.startDate"
                  type="date"
                  :placeholder="$t('common.pick_a_date')"
                  :picker-options="pickerOptions">
              </el-date-picker>
            </el-col>
            <el-col v-if="error_message.data.period.startDate" :span="12">
              <span v-for="(value, key) in error_message.data.period.startDate" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.end_date') }}</span>
            </el-col>
            <el-col :span="8">
              <el-date-picker
                  v-model="data.period.endDate"
                  type="date"
                  :placeholder="$t('common.pick_a_date')"
                  :picker-options="pickerOptions">
              </el-date-picker>
            </el-col>
            <el-col v-if="error_message.data.period.endDate" :span="12">
              <span v-for="(value, key) in error_message.data.period.endDate" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-row>
        </template>

        <el-row style="padding: 50px 0">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}
          </el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  // import
  import PageTitle from '@/components/PageTitle'
  import {
    DAY_OFF_TYPE_DATE,
    DAY_OFF_TYPE_DAY,
    DAY_OFF_TYPE_PERIOD,
    DAY_LIST_FULL
  } from '@/config'

  export default {
    name: "AddDayOff",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: '/general/day-off?action=back',
        title: 'day_off.add_day_off',
        type: '',
        dayOffTitle: '',
        data: {
          date: {
            date: null
          },
          day: {
            day: null,
            startDate: null,
            endDate: null
          },
          period: {
            startDate: null,
            endDate: null
          }
        },
        DAY_OFF_TYPE_DATE,
        DAY_OFF_TYPE_DAY,
        DAY_OFF_TYPE_PERIOD,
        DAY_LIST_FULL,
        error_message: {
          type: [],
          dayOffTitle: [],
          data: {
            date: {
              date: []
            },
            day: {
              day: [],
              startDate: [],
              endDate: []
            },
            period: {
              startDate: [],
              endDate: []
            }
          }
        },
        pickerOptions: {
          disabledDate: (date) => {
            let currentDate = this.$moment().format('YYYY-MM-DD')
            let currentTime = this.$moment(currentDate).valueOf()
            let time = this.$moment(date).valueOf()

            return time < currentTime
          }
        }
      }
    },
    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let data

          switch (this.type) {
            case DAY_OFF_TYPE_DATE:
              data = {
                date: this.$moment(this.data.date.date).format('YYYY-MM-DD')
              }

              break
            case DAY_OFF_TYPE_DAY:
              data = {
                day: this.data.day.day,
                start_date: this.$moment(this.data.day.startDate).format('YYYY-MM-DD'),
                end_date: this.$moment(this.data.day.endDate).format('YYYY-MM-DD')
              }

              break
            default:
              data = {
                start_date: this.$moment(this.data.period.startDate).format('YYYY-MM-DD'),
                end_date: this.$moment(this.data.period.endDate).format('YYYY-MM-DD')
              }

              break
          }

          let successCallback = () => {
            this.$router.push({path: '/general/day-off'})
          }

          this.$store.dispatch('dayOff/createDayOff', {
            title: this.dayOffTitle.trim(),
            type: this.type,
            data,
            successCallback
          })
        }
      },
      validate: function () {
        var check = true
        this.error_message.dayOffTitle = []
        if (this.dayOffTitle.trim() === "") {
          this.error_message.dayOffTitle.push('* ' + this.$t('common.title_is_required'))
          check = false
        }

        this.error_message.type = []
        if (!this.type) {
          check = false
          this.error_message.type.push('* ' + this.$t('common.type_is_required'))
        }

        switch (this.type) {
          case DAY_OFF_TYPE_DATE:
            if (!this.data.date.date) {
              check = false
              this.error_message.data.date.date.push('* ' + this.$t('common.date_is_required'))
            }

            break
          case DAY_OFF_TYPE_DAY:
            if (!this.data.day.day) {
              check = false
              this.error_message.data.day.day.push('* ' + this.$t('common.day_is_required'))
            }

            if (!this.error_message.data.day.startDate) {
              check = false
              this.error_message.data.day.startDate.push('* ' + this.$t('common.start_date_is_required'))
            }

            if (!this.error_message.data.day.endDate) {
              check = false
              this.error_message.data.day.endDate.push('* ' + this.$t('common.end_date_is_required'))
            }

            break
          default:
            if (!this.error_message.data.period.startDate) {
              check = false
              this.error_message.data.period.startDate.push('* ' + this.$t('common.start_date_is_required'))
            }

            if (!this.error_message.data.period.endDate) {
              check = false
              this.error_message.data.period.endDate.push('* ' + this.$t('common.end_date_is_required'))
            }

            break
        }

        return check
      }
    },
    mounted: function () {

    },
    computed: {

    }
  }
</script>

<style lang="scss">
  .add-day-off {
    form {
      .el-row {
        margin-top: 20px;
      }

      .input, .el-input, .el-select {
        width: 100%;
      }
    }
  }
</style>